angular.module('picmonicng').factory('ReplaceCardModal', [
  '$modal',
  function ($modal) {
    return {
      show: function () {
        return $modal.open({
          templateUrl: '/templates/modals/my-subscriptions-replace-card.html',
          windowClass: 'learn-light-modal',
          backdrop: 'static',
          keyboard: true,
          controller: [
            '$scope',
            'User',
            'UserService',
            function ($scope, User, UserService) {
              var addressElement;
              User.payment_info(function (data) {
                $scope.credit_card = data;
                $scope.address = data.address;
              });

              var elements = stripe.elements();
              var cardElement = elements.create('card', {
                hidePostalCode: true,
              });

              $scope.createCardElement = function () {
                cardElement.mount('#stripe-card-element');
              };

              $scope.createAddressElement = function () {
                addressElement = elements.create('address', {
                  mode: 'billing',
                  defaultValues: {
                    name: UserService.user.first_name + ' ' + UserService.user.last_name,
                    address: {
                      line1: $scope.address.address,
                      line2: $scope.address.address2,
                      city: $scope.address.city,
                      state: $scope.address.state,
                      postal_code: $scope.address.zipcode,
                      country: $scope.address.country,
                    },
                  },
                });
                addressElement.mount('#stripe-address-element');
              };

              $scope.card = {
                exp: null,
              };

              var year = new Date().getFullYear();
              $scope.years = [];
              for (var x = 0; x < 10; x++) {
                $scope.years.push(year + x);
              }

              $scope.updateCreditCard = function () {
                if ($scope.loading) {
                  return;
                }

                $scope.loading = true;
                $scope.error = false;
                $scope.msg = 'Please wait while we update your credit card ...';

                addressElement.getValue().then(function (value) {
                  if (!value.complete) {
                    $scope.$apply(function () {
                      $scope.loading = false;
                      $scope.error = true;
                      $scope.msg = 'Please complete your address';
                    });
                    return;
                  }
                  var address = value.value.address;
                  stripe
                    .createToken(cardElement, {
                      address_line1: address.line1,
                      address_line2: address.line2 || '',
                      address_city: address.city,
                      address_state: address.state,
                      address_zip: address.postal_code,
                      address_country: address.country,
                    })
                    .then(function (result) {
                      $scope.$apply(function () {
                        if (result.error) {
                          $scope.msg = result.error.message;
                          $scope.error = true;
                          $scope.loading = false;
                        } else {
                          var card = result.token.card;
                          var request = {
                            profile_id: $scope.credit_card.profile_id,
                            payment_profile_id: $scope.credit_card.payment_profile_id,
                            token: result.token.id,
                            funding: result.token.card.funding,
                            address: {
                              address: card.address_line1,
                              address2: card.address_line2,
                              city: card.address_city,
                              state: card.address_state,
                              zipcode: card.address_zip,
                              country: card.address_country,
                            },
                          };

                          User.update_payment_info(
                            request,
                            function (data) {
                              $scope.$close();
                            },
                            function (response) {
                              $scope.loading = false;
                              $scope.error = true;
                              $scope.msg = response.data.message;
                            }
                          );
                        }
                      });
                    });
                });
              };

              $scope.cancel = function () {
                $scope.$dismiss('cancel');
              };
            },
          ],
        });
      },
    };
  },
]);
